import _regeneratorRuntime from "/Users/dayanamartinez/Developer/laas_simulator/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/dayanamartinez/Developer/laas_simulator/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import request from "@/routes/api/api_conextion";
import axios from "axios";
// eslint-disable-next-line no-unused-vars
import { getFromLocal, saveInLocal } from "@/commons/utils/storage";
function getResourece(resource) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return new Promise(function (resolve) {
    setTimeout(function () {
      request({
        url: resource,
        method: "get",
        params: params
      }).then(function (request) {
        // saveInLocal(resource, request)
        resolve(request);
      });
    }, 1000);
  });
}
export function getEstadoCivil() {
  return _getEstadoCivil.apply(this, arguments);
}
function _getEstadoCivil() {
  _getEstadoCivil = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", getResourece("/marital-status"));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getEstadoCivil.apply(this, arguments);
}
export function getSucursales(_x) {
  return _getSucursales.apply(this, arguments);
}
function _getSucursales() {
  _getSucursales = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(id) {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.abrupt("return", getResourece("/sucursales/" + id));
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _getSucursales.apply(this, arguments);
}
export function getTipoViviendas() {
  return _getTipoViviendas.apply(this, arguments);
}
function _getTipoViviendas() {
  _getTipoViviendas = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.abrupt("return", getResourece("/properties"));
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _getTipoViviendas.apply(this, arguments);
}
export function getEstudios() {
  return _getEstudios.apply(this, arguments);
}
function _getEstudios() {
  _getEstudios = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          return _context4.abrupt("return", getResourece("/studies"));
        case 1:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _getEstudios.apply(this, arguments);
}
export function getFormasDeEnterarse() {
  return _getFormasDeEnterarse.apply(this, arguments);
}
function _getFormasDeEnterarse() {
  _getFormasDeEnterarse = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          return _context5.abrupt("return", getResourece("/find-out"));
        case 1:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _getFormasDeEnterarse.apply(this, arguments);
}
export function getRelacionesLaborales() {
  return _getRelacionesLaborales.apply(this, arguments);
}
function _getRelacionesLaborales() {
  _getRelacionesLaborales = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          return _context6.abrupt("return", getResourece("/employment-relations"));
        case 1:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _getRelacionesLaborales.apply(this, arguments);
}
export function getCoinTypes() {
  return _getCoinTypes.apply(this, arguments);
}
function _getCoinTypes() {
  _getCoinTypes = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          return _context7.abrupt("return", getResourece("/coinTypes"));
        case 1:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _getCoinTypes.apply(this, arguments);
}
export function getSelds() {
  return _getSelds.apply(this, arguments);
}
function _getSelds() {
  _getSelds = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          return _context8.abrupt("return", getResourece("/workers"));
        case 1:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return _getSelds.apply(this, arguments);
}
export function getVentasTop() {
  return _getVentasTop.apply(this, arguments);
}
function _getVentasTop() {
  _getVentasTop = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          return _context9.abrupt("return", getResourece("/ventasTop"));
        case 1:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return _getVentasTop.apply(this, arguments);
}
export function getDepartamentos() {
  return _getDepartamentos.apply(this, arguments);
}
function _getDepartamentos() {
  _getDepartamentos = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
    return _regeneratorRuntime().wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          return _context10.abrupt("return", getResourece("/departamentos"));
        case 1:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return _getDepartamentos.apply(this, arguments);
}
export function getBancos() {
  return _getBancos.apply(this, arguments);
}
function _getBancos() {
  _getBancos = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
    return _regeneratorRuntime().wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          return _context11.abrupt("return", getResourece("/bancos"));
        case 1:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
  return _getBancos.apply(this, arguments);
}
export function getRubros() {
  return _getRubros.apply(this, arguments);
}
function _getRubros() {
  _getRubros = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
    return _regeneratorRuntime().wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          return _context12.abrupt("return", getResourece("/rubros"));
        case 1:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  }));
  return _getRubros.apply(this, arguments);
}
export function getMunicipios(_x2) {
  return _getMunicipios.apply(this, arguments);
}
function _getMunicipios() {
  _getMunicipios = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13(params) {
    return _regeneratorRuntime().wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          return _context13.abrupt("return", getResourece("/getMunicipios/" + params));
        case 1:
        case "end":
          return _context13.stop();
      }
    }, _callee13);
  }));
  return _getMunicipios.apply(this, arguments);
}
export function getLocalidad(_x3) {
  return _getLocalidad.apply(this, arguments);
}
function _getLocalidad() {
  _getLocalidad = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14(params) {
    return _regeneratorRuntime().wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          return _context14.abrupt("return", getResourece("/getLocalidad/" + params));
        case 1:
        case "end":
          return _context14.stop();
      }
    }, _callee14);
  }));
  return _getLocalidad.apply(this, arguments);
}
export function getMunicipiosByName(_x4) {
  return _getMunicipiosByName.apply(this, arguments);
}
function _getMunicipiosByName() {
  _getMunicipiosByName = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15(params) {
    return _regeneratorRuntime().wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          return _context15.abrupt("return", getResourece("/municipio/" + params));
        case 1:
        case "end":
          return _context15.stop();
      }
    }, _callee15);
  }));
  return _getMunicipiosByName.apply(this, arguments);
}
export function getLocalidadByName(_x5) {
  return _getLocalidadByName.apply(this, arguments);
}
function _getLocalidadByName() {
  _getLocalidadByName = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee16(params) {
    return _regeneratorRuntime().wrap(function _callee16$(_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          return _context16.abrupt("return", getResourece("/localidad/" + params));
        case 1:
        case "end":
          return _context16.stop();
      }
    }, _callee16);
  }));
  return _getLocalidadByName.apply(this, arguments);
}
export function getDepartamentoByName(_x6) {
  return _getDepartamentoByName.apply(this, arguments);
}
function _getDepartamentoByName() {
  _getDepartamentoByName = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee17(params) {
    return _regeneratorRuntime().wrap(function _callee17$(_context17) {
      while (1) switch (_context17.prev = _context17.next) {
        case 0:
          return _context17.abrupt("return", getResourece("/departamento/" + params));
        case 1:
        case "end":
          return _context17.stop();
      }
    }, _callee17);
  }));
  return _getDepartamentoByName.apply(this, arguments);
}
export function getDocumentsType(_x7) {
  return _getDocumentsType.apply(this, arguments);
}
function _getDocumentsType() {
  _getDocumentsType = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee18(params) {
    var active,
      _args18 = arguments;
    return _regeneratorRuntime().wrap(function _callee18$(_context18) {
      while (1) switch (_context18.prev = _context18.next) {
        case 0:
          active = _args18.length > 1 && _args18[1] !== undefined ? _args18[1] : true;
          return _context18.abrupt("return", getResourece("/documents/" + params + "/" + active));
        case 2:
        case "end":
          return _context18.stop();
      }
    }, _callee18);
  }));
  return _getDocumentsType.apply(this, arguments);
}
export function getPaises(_x8) {
  return _getPaises.apply(this, arguments);
}
function _getPaises() {
  _getPaises = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee19(params) {
    return _regeneratorRuntime().wrap(function _callee19$(_context19) {
      while (1) switch (_context19.prev = _context19.next) {
        case 0:
          return _context19.abrupt("return", getResourece("/getPaises", params));
        case 1:
        case "end":
          return _context19.stop();
      }
    }, _callee19);
  }));
  return _getPaises.apply(this, arguments);
}
export function getPais(_x9) {
  return _getPais.apply(this, arguments);
}
function _getPais() {
  _getPais = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee20(id) {
    return _regeneratorRuntime().wrap(function _callee20$(_context20) {
      while (1) switch (_context20.prev = _context20.next) {
        case 0:
          return _context20.abrupt("return", getResourece("/getPaises/" + id));
        case 1:
        case "end":
          return _context20.stop();
      }
    }, _callee20);
  }));
  return _getPais.apply(this, arguments);
}
export function getDirectionConfig() {
  return _getDirectionConfig.apply(this, arguments);
}
function _getDirectionConfig() {
  _getDirectionConfig = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
    return _regeneratorRuntime().wrap(function _callee21$(_context21) {
      while (1) switch (_context21.prev = _context21.next) {
        case 0:
          return _context21.abrupt("return", getResourece("/direction/config"));
        case 1:
        case "end":
          return _context21.stop();
      }
    }, _callee21);
  }));
  return _getDirectionConfig.apply(this, arguments);
}
export function getFormasPago() {
  return _getFormasPago.apply(this, arguments);
}
function _getFormasPago() {
  _getFormasPago = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
    return _regeneratorRuntime().wrap(function _callee22$(_context22) {
      while (1) switch (_context22.prev = _context22.next) {
        case 0:
          return _context22.abrupt("return", getResourece("/getFormasPago"));
        case 1:
        case "end":
          return _context22.stop();
      }
    }, _callee22);
  }));
  return _getFormasPago.apply(this, arguments);
}
export function getDocIde(_x10) {
  return _getDocIde.apply(this, arguments);
}
function _getDocIde() {
  _getDocIde = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee23(id) {
    return _regeneratorRuntime().wrap(function _callee23$(_context23) {
      while (1) switch (_context23.prev = _context23.next) {
        case 0:
          return _context23.abrupt("return", getResourece("/getdocide/" + id));
        case 1:
        case "end":
          return _context23.stop();
      }
    }, _callee23);
  }));
  return _getDocIde.apply(this, arguments);
}
export function getInstantorSettings() {
  return _getInstantorSettings.apply(this, arguments);
}
function _getInstantorSettings() {
  _getInstantorSettings = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
    return _regeneratorRuntime().wrap(function _callee24$(_context24) {
      while (1) switch (_context24.prev = _context24.next) {
        case 0:
          return _context24.abrupt("return", getResourece("/instantor/config"));
        case 1:
        case "end":
          return _context24.stop();
      }
    }, _callee24);
  }));
  return _getInstantorSettings.apply(this, arguments);
}
export function getRequisitos(_x11) {
  return _getRequisitos.apply(this, arguments);
}
function _getRequisitos() {
  _getRequisitos = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee25(id) {
    return _regeneratorRuntime().wrap(function _callee25$(_context25) {
      while (1) switch (_context25.prev = _context25.next) {
        case 0:
          return _context25.abrupt("return", getResourece("/requisitosgarante/" + id));
        case 1:
        case "end":
          return _context25.stop();
      }
    }, _callee25);
  }));
  return _getRequisitos.apply(this, arguments);
}
export function validateContact(_x12, _x13, _x14) {
  return _validateContact.apply(this, arguments);
}
function _validateContact() {
  _validateContact = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee26(email, phone, document) {
    return _regeneratorRuntime().wrap(function _callee26$(_context26) {
      while (1) switch (_context26.prev = _context26.next) {
        case 0:
          return _context26.abrupt("return", getResourece("/validarcontacto?" + "email=" + email + "&phone=" + phone + "&document=" + document));
        case 1:
        case "end":
          return _context26.stop();
      }
    }, _callee26);
  }));
  return _validateContact.apply(this, arguments);
}
export function getIp() {
  return _getIp.apply(this, arguments);
}
function _getIp() {
  _getIp = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee27() {
    return _regeneratorRuntime().wrap(function _callee27$(_context27) {
      while (1) switch (_context27.prev = _context27.next) {
        case 0:
          return _context27.abrupt("return", axios.create({
            baseURL: process.env.VUE_APP_IPL_URL,
            // url = base url + request url
            // withCredentials: true, // send cookies when cross-domain requests
            timeout: 5000 // request timeout
          }).get("/json"));
        case 1:
        case "end":
          return _context27.stop();
      }
    }, _callee27);
  }));
  return _getIp.apply(this, arguments);
}
export function getMotivoRechazo(_x15) {
  return _getMotivoRechazo.apply(this, arguments);
}
function _getMotivoRechazo() {
  _getMotivoRechazo = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee28(loan) {
    var ruta;
    return _regeneratorRuntime().wrap(function _callee28$(_context28) {
      while (1) switch (_context28.prev = _context28.next) {
        case 0:
          ruta = loan ? "/getmotivorechazo/" + loan : "/getmotivorechazo";
          return _context28.abrupt("return", getResourece(ruta));
        case 2:
        case "end":
          return _context28.stop();
      }
    }, _callee28);
  }));
  return _getMotivoRechazo.apply(this, arguments);
}
export function validateNames(_x16, _x17, _x18) {
  return _validateNames.apply(this, arguments);
}
function _validateNames() {
  _validateNames = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee29(type, names, document) {
    return _regeneratorRuntime().wrap(function _callee29$(_context29) {
      while (1) switch (_context29.prev = _context29.next) {
        case 0:
          return _context29.abrupt("return", getResourece("/validarnames?" + "type=" + type + "&names=" + names + "&document=" + document));
        case 1:
        case "end":
          return _context29.stop();
      }
    }, _callee29);
  }));
  return _validateNames.apply(this, arguments);
}
export function getTextProduct(_x19) {
  return _getTextProduct.apply(this, arguments);
}
function _getTextProduct() {
  _getTextProduct = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee30(params) {
    return _regeneratorRuntime().wrap(function _callee30$(_context30) {
      while (1) switch (_context30.prev = _context30.next) {
        case 0:
          return _context30.abrupt("return", getResourece("/getTextProduct/" + params));
        case 1:
        case "end":
          return _context30.stop();
      }
    }, _callee30);
  }));
  return _getTextProduct.apply(this, arguments);
}
export function getEmpresasOferentes() {
  return _getEmpresasOferentes.apply(this, arguments);
}
function _getEmpresasOferentes() {
  _getEmpresasOferentes = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee31() {
    return _regeneratorRuntime().wrap(function _callee31$(_context31) {
      while (1) switch (_context31.prev = _context31.next) {
        case 0:
          return _context31.abrupt("return", getResourece("/getEmpresasOferentes"));
        case 1:
        case "end":
          return _context31.stop();
      }
    }, _callee31);
  }));
  return _getEmpresasOferentes.apply(this, arguments);
}
export function getMensajeFinal(_x20) {
  return _getMensajeFinal.apply(this, arguments);
}
function _getMensajeFinal() {
  _getMensajeFinal = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee32(params) {
    return _regeneratorRuntime().wrap(function _callee32$(_context32) {
      while (1) switch (_context32.prev = _context32.next) {
        case 0:
          return _context32.abrupt("return", getResourece("/getMensajeFinal/" + params));
        case 1:
        case "end":
          return _context32.stop();
      }
    }, _callee32);
  }));
  return _getMensajeFinal.apply(this, arguments);
}
export function getAgrupacion1() {
  return _getAgrupacion.apply(this, arguments);
}
function _getAgrupacion() {
  _getAgrupacion = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee33() {
    return _regeneratorRuntime().wrap(function _callee33$(_context33) {
      while (1) switch (_context33.prev = _context33.next) {
        case 0:
          return _context33.abrupt("return", getResourece("/agrupacion1"));
        case 1:
        case "end":
          return _context33.stop();
      }
    }, _callee33);
  }));
  return _getAgrupacion.apply(this, arguments);
}
export function getAgrupacion2(_x21) {
  return _getAgrupacion2.apply(this, arguments);
}
function _getAgrupacion2() {
  _getAgrupacion2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee34(params) {
    return _regeneratorRuntime().wrap(function _callee34$(_context34) {
      while (1) switch (_context34.prev = _context34.next) {
        case 0:
          return _context34.abrupt("return", getResourece("/agrupacion2/" + params));
        case 1:
        case "end":
          return _context34.stop();
      }
    }, _callee34);
  }));
  return _getAgrupacion2.apply(this, arguments);
}
export function getAgrupacion3(_x22) {
  return _getAgrupacion3.apply(this, arguments);
}
function _getAgrupacion3() {
  _getAgrupacion3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee35(params) {
    return _regeneratorRuntime().wrap(function _callee35$(_context35) {
      while (1) switch (_context35.prev = _context35.next) {
        case 0:
          return _context35.abrupt("return", getResourece("/agrupacion3/" + params));
        case 1:
        case "end":
          return _context35.stop();
      }
    }, _callee35);
  }));
  return _getAgrupacion3.apply(this, arguments);
}